import {
  AfterViewInit,
  Component,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Output,
  PLATFORM_ID,
  TemplateRef,
  ViewChild
} from '@angular/core';
import {TranslateService} from "@ngx-translate/core";
import {IMeta, MetaService} from "@shared/services/web/meta.service";
import {environment} from "@env/environment";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {finalize, Subscription} from "rxjs";
import {ActivatedRoute, Router} from "@angular/router";
import {AuthenticationService} from "@app/auth/authentication.service";
import {ToastrService} from "@shared/services/web/toastr.service";
import {CredentialsService} from "@shared/services/web/credentials.service";
import {BreadcrumbsService} from "@shared/services/web/breadcrumbs.service";
import {isPlatformBrowser} from "@angular/common";
import {untilDestroyed} from "@core/until-destroyed";
import {RedirectRouterService} from "@shared/services/web/redirect-router.service";
import {FacebookService} from "@shared/services/api/facebook.service";
import {PropertiesService} from "@shared/services/api/properties.service";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";

declare var google: any;

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit, AfterViewInit {


  @Output() loginOk = new EventEmitter();
  @Output() passwordRecovery = new EventEmitter();
  @Input() routeWizard = false;
  @Input() emailParam = '';
  @ViewChild('modalActivation') modalActivation: TemplateRef<any> | undefined;

  version: string | null = environment.version;
  error: string | undefined;
  loginForm!: FormGroup;
  SendEmailForm!: FormGroup;
  isLoading = false;
  submitted = false;
  disabledButton = false;
  menuHidden = true;
  showPassword = true;
  spinnerDecider: any = undefined;
  language = '';
  visibilityForm = false;
  loadingGoogle = false;
  changeLangSubscription: Subscription;
  googleRequest: any;

  constructor(
      public translateService: TranslateService,
      private metaService: MetaService,
      private router: Router,
      private route: ActivatedRoute,
      private formBuilder: FormBuilder,
      private authenticationService: AuthenticationService,
      private toastrService: ToastrService,
      public credentialsService: CredentialsService,
      private facebookService: FacebookService,
      private modalService: NgbModal,
      private services: PropertiesService,
      public redirectService: RedirectRouterService,
      private breadcrumbsService: BreadcrumbsService,
      @Inject(PLATFORM_ID) private platformId: any

  ) {
    this.createForm();
    this.initializeFormSend();
    this.setBreadcrumb();
    this.translateService.onLangChange.subscribe(() => {
      this.changeMeta();
    });
  }

  changeMeta() {
    const meta: IMeta = {
      language: this.translateService.currentLang,
      title: 'login',
      description: 'login_desc',
    };
    this.metaService.changeMeta(meta);
  }

  ngOnInit() {
    if (this.credentialsService.isAuthenticated()) {
      this.router.navigate(['/'], { replaceUrl: true });
    }
    this.loginForm.get('email')?.setValue(this.emailParam);
  }

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.googleRequest = google.accounts.oauth2.initTokenClient({
        client_id: environment.GOOGLE_APP_ID,
        scope:
            'https://www.googleapis.com/auth/userinfo.profile ' +
            'https://www.googleapis.com/auth/userinfo.email ' +
            'https://www.googleapis.com/auth/plus.me',
        prompt: 'consent',
        callback: (tokenResponse: any) => {
          this.loginWithGoogle(tokenResponse.access_token);
        },
      });
    }
  }

  setBreadcrumb() {
    this.breadcrumbsService.setBreadcrumb([]);
  }

  toggleMenu() {
    this.menuHidden = !this.menuHidden;
  }

  async logout() {
    this.authenticationService.logout();
  }

  get username(): string | undefined | null {
    const credentials = this.credentialsService.credentials;
    return credentials ? credentials.email : null;
  }

  ngOnDestroy() {}

  hidePassword() {
    this.showPassword = !this.showPassword;
  }

  login(user?: any) {
    if (Number(this.spinnerDecider) !== 2) {
      this.isLoading = true;
      if (user) this.loginForm.get('email')?.setValue(user.email);
      const login$ = this.authenticationService.login(this.loginForm.value);
      login$
          .pipe(
              finalize(() => {
                this.loginForm.markAsPristine();
                this.isLoading = false;
              }),
              untilDestroyed(this)
          )
          .subscribe(
              () => {
                this.toastrService.success('a Inviertis', 'Bienvenido');
                this.loginOk.emit({
                  route: 'ingresar',
                });
                if (!this.routeWizard) {
                  this.redireccionExitosa();
                }
              },
              (error: any) => {
                if (error.error.type === 'activation') {
                  // this.modalService.open(this.modalActivation);
                } else {
                  this.toastrService.error(error.error.message, 'Ingreso fallido');
                }
                this.error = error;
              }
          );
    }
  }

  redireccionExitosa() {
    let returnUrl = '';
    let params: any = {}
    for (const key in this.route.snapshot.queryParams) {
      if (key === 'redirect') {
        returnUrl = decodeURI(this.route.snapshot.queryParams[key]);
      } else {
        params[key] = this.route.snapshot.queryParams[key];
      }
    }
    if (returnUrl.split('?').length > 1) {
      params = JSON.parse(
          '{"' +
          decodeURI(returnUrl.split('?')[1])
              .replace(/"/g, '\\"')
              .replace(/&/g, '","')
              .replace(/=/g, '":"') +
          '"}'
      );
    }
    this.router.navigate([returnUrl.split('?')[0]], { queryParams: params });
  }

  initializeFormSend() {
    this.SendEmailForm = this.formBuilder.group({
      email: [
        '',
        [
          Validators.required,
          Validators.pattern(
              /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          ),
        ],
      ],
    });
  }

  createForm() {
    this.loginForm = this.formBuilder.group({
      email: ['', Validators.required],
      password: ['', Validators.required],
      remember: true,
    });
  }

  async loginWithFacebook() {
    this.facebookService.loginWithFacebook().then( (user: any) => {

      if (user) {
        this.authenticationService
            .loginFb(user)
            .pipe(
                finalize(() => {
                  this.loginForm.markAsPristine();
                  this.isLoading = false;
                }),
                untilDestroyed(this)
            )
            .subscribe(
                () => {
                  this.toastrService.success('a Inviertis', 'Bienvenido');
                  this.loginOk.emit({
                    route: 'ingresar',
                  });
                  if (!this.routeWizard) {
                    this.redireccionExitosa();
                  }
                },
                (error: any) => {
                  this.toastrService.error(error.error.message, 'Ingreso fallido');
                  this.error = error;
                }
            );
      }

    });
  }
  loginWithGoogle(token: any) {
    if (token) {
      this.authenticationService
          .loginGoogle(token)
          .pipe(
              finalize(() => {
                this.loginForm.markAsPristine();
                this.isLoading = false;
              }),
              untilDestroyed(this)
          )
          .subscribe(
              () => {
                this.toastrService.success('a Inviertis', 'Bienvenido');
                this.loginOk.emit({
                  route: 'ingresar',
                });
                if (!this.routeWizard) {
                  this.redireccionExitosa();
                }
              },
              (error: any) => {
                this.toastrService.error(error.error.message, 'Ingreso fallido');
                this.error = error;
              }
          );
    }
  }

  updateForm(user: any) {
    this.loginForm.patchValue({
      email: user.email,
    });
  }

  redirectPasswordRecovery() {
    this.passwordRecovery.emit({});
  }

  reSendEmail() {
    this.submitted = true;
    this.disabledButton = true;
    if (this.SendEmailForm.valid) {
      this.services.SendEmail(this.SendEmailForm.value).subscribe(
          (resp) => {
            this.toastrService.success(
                'Email de activacion enviado correctamente.',
                'Éxito'
            );
            this.disabledButton = false;
            this.modalService.dismissAll();
          },
          (err) => {
            this.disabledButton = false;
            this.toastrService.error('Error al enviar, intente nuevamente.', 'Error');
          }
      );
    } else {
      this.disabledButton = false;
      return;
    }
  }

  buttonSpinnerHandler(n: number) {
    return (this.spinnerDecider = n);
  }


}
